<template>
  <!-- name: '登记可捐衣物-已登记' -->
  <div class="registerWrap">
    <div class="titleBox">
      <h4>
        我的登记
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_help.svg"
          alt=""
          @click="showDialog = true"
        />
      </h4>
      <span @click="handleSave">保存</span>
    </div>
    <div class="listBox">
      <ul>
        <li v-for="(item, index) in dataList" :key="index">
          <input
            type="checkbox"
            class="checkboxClass"
            :checked="item.isCheck"
            @click="checkClick(index)"
          />
          <span class="sizeClass">
            {{ item.sizeHeightName }}
          </span>
          <span class="sexClass">
            {{ item.sexName }}
          </span>
          <span>{{ item.seasonName }}</span>
          <div class="countBox">
            <img
              :src="`https://img.bbalt.cn/imgh5/donate/icon_minus${item.redundantCount === 0 ? '' : '_act'}.svg`"
              
              alt=""
              @click="
                () => {
                  item.redundantCount--;
                  item.redundantCount < 0 && (item.redundantCount = 0);
                }
              "
            />
            <input
              type="tel"
              class="numberboxClass"
              v-model="item.redundantCount"
              @mousedown="curCount = item.redundantCount"
              @mouseleave="handleCount(index, item.redundantCount)"
            />
            <img
              src="https://img.bbalt.cn/imgh5/userCenter/icon_add.svg"
              alt=""
              @click="item.redundantCount++"
            />
          </div>
          <img
            src="https://img.bbalt.cn/imgh5/userCenter/icon_delete.svg"
            alt=""
            class="deleteClass"
            @click="handleDelete(index)"
          />
        </li>
      </ul>
    </div>
    <button class="addInfoClass" @click="showRight = true">添加信息</button>
    <div class="footBox">
      <div :class="isBeiLan ? 'btnListBox beiLanClass' : 'btnListBox'">
        <span
          ><input
            type="checkbox"
            id="allCheck"
            :checked="isAllCheck"
            @click="setAllCheck"
          /><label for="allCheck">全选</label></span
        >
        <span v-show="isBeiLan">
          <img src="https://img.bbalt.cn/imgh5/userCenter/icon_otherDonate.svg" alt="" />
          其他捐赠
        </span>
        <span v-show="isBeiLan">
          <img src="https://img.bbalt.cn/imgh5/userCenter/icon_otherHandle.svg" alt="" />
          其他处理
        </span>
      </div>
      <div class="beiLanBtn" v-if="isBeiLan">
        <button>回收</button>
        <button
          @click="
            $router.push({
              path: '/userCenterThird',
              query: { title: '可捐衣物匹配' },
            })
          "
        >
          匹配
        </button>
      </div>
      <button v-else @click="handleFastMatch()" class="buttonClass">
        立即匹配
      </button>
    </div>
    <van-popup
      v-model="showRight"
      v-if="showRight"
      position="right"
      :style="{ width: '80%', height: '100%' }"
    >
      <div class="titleClass">性别</div>
      <ul>
        <li
          v-for="(value, key, index) in rightObj.gender"
          :key="index"
          @click="
            curAddSexID = value;
            curAddSexName = key;
          "
          :class="{ active: curAddSexName === key }"
        >
          {{ key }}
        </li>
      </ul>
      <div class="titleClass">身高</div>
      <ul>
        <li
          v-for="(value, key, index) in rightObj.sizeHeight"
          :key="index"
          @click="
            curAddHeightID = value;
            curAddHeightName = key;
          "
          :class="{ active: curAddHeightName === key }"
        >
          {{ key }}
        </li>
      </ul>
      <div class="titleClass">季节</div>
      <ul>
        <li
          v-for="(value, key, index) in rightObj.season"
          :key="index"
          @click="
            curAddSeasonID = value;
            curAddSeasonName = key;
          "
          :class="{ active: curAddSeasonName === key }"
        >
          {{ key }}
        </li>
      </ul>
      <div class="titleClass">数量</div>
      <div class="countBox">
        <img
          :src="
            `https://img.bbalt.cn/imgh5/donate/icon_minus${
              curDonateCount === 0 ? '' : '_act'
            }.svg`
          "
          alt=""
          @click="
            () => {
              curDonateCount--;
              curDonateCount < 0 && (curDonateCount = 0);
            }
          "
        />
        <input type="tel" class="numberboxClass" v-model="curDonateCount" />
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_add.svg"
          alt=""
          @click="curDonateCount++"
        />
      </div>
      <div class="buttonBox">
        <button class="cancelButton" @click="showRight = false">取消</button>
        <button class="rightButton" @click="addData">确认</button>
      </div>
    </van-popup>

    <van-dialog
      v-model="showDialog"
      title="衣物登记说明"
      confirmButtonColor="#00a392"
    >
      <p>
        如果衣物缺口暂时没有您想捐的衣物，请整理并再次登记您想捐的衣物信息。有新需求上线，如果符合您登记的信息时，我们会第一时间通知您。
      </p>
      <p>登记的可捐衣物需要符合8成新，无污渍的捐赠要求，感谢您的支持。</p>
    </van-dialog>
  </div>
</template>

<script>
import {
  myDonatemMatch,
  myClothes,
  addMyClothes,
  myDonateQueryCondition,
} from "@/api/other.js";
export default {
  components: {},
  data() {
    return {
      isBeiLan: false, //判断是贝蓝还是个人
      dataList: [],
      curCount: 0,
      isAllCheck: false,
      curList: [],
      showSexPicker: false,
      showRight: false,
      curAddSexName: "男",
      curAddHeightName: "150cm",
      curAddSeasonName: "冬装",
      curAddSexID: "1798",
      curAddHeightID: "1785",
      curAddSeasonID: "1802",
      curDonateCount: 1,
      showDialog: false,
      rightObj: {},
      isSave: true,
    };
  },
  created() {
    this.getMyClothes();
    this.getMyDonateQueryCondition();
  },
  methods: {
    handleCount(index, val) {
      this.dataList[index].redundantCount = Number(val) ? val : this.curCount;
    },
    checkClick(index) {
      this.dataList[index].isCheck = !this.dataList[index].isCheck;
      if (this.dataList.every((item) => item.isCheck === true)) {
        this.isAllCheck = true;
      } else {
        this.isAllCheck = false;
      }
    },
    setAllCheck() {
      this.isAllCheck = !this.isAllCheck;
      this.dataList = this.dataList.map((item) => {
        item.isCheck = this.isAllCheck;
        return item;
      });
    },
    handleDelete(index) {
      this.dataList.splice(index, 1);
      this.isSave = false;
    },
    async handleSave() {
      let tempList = this.dataList.map((item) => {
        let obj = {
          categoryId: "",
          goodsId: "",
          redundantCount: item.redundantCount,
          season: item.season,
          sex: item.sex,
          sizeHeight: item.sizeHeight,
        };
        return obj;
      });
      const { code, message } = await addMyClothes({
        type: 1,
        clothesArgs: tempList,
      });
      if (code === 200) {
        this.$toast.success("保存成功!");
        this.isSave = true;
      } else {
        this.$toast.fail(message);
      }
    },
    async handleFastMatch() {
      if (this.isSave) {
        this.dataList.map((item) => {
          if (item.isCheck) {
            this.curList.push({
              categoryId: "",
              donateCount: item.redundantCount,
              goodsId: "",
              season: item.season,
              sex: item.sex,
              sizeHeight: item.size,
            });
          }
        });
        if (this.curList.length > 0) {
          const { code, message, content } = await myDonatemMatch({
            type: 1,
            detailArgList: this.curList,
          });
          if (code === 200) {
            this.$router.push({
              path: "/userCenterThird",
              query: { title: "可捐衣物匹配", data: content },
            });
          } else {
            this.$toast.fail(message);
          }
        } else {
          this.$toast.fail("请选择要匹配的数据");
        }
      } else {
        this.$toast.fail("请保存更改过的数据");
      }
    },
    addData() {
      this.dataList.push({
        sex: this.curAddSexID,
        sizeHeight: this.curAddHeightID,
        season: this.curAddSeasonID,
        sexName: this.curAddSexName,
        sizeHeightName: this.curAddHeightName,
        seasonName: this.curAddSeasonName,
        redundantCount: this.curDonateCount,
        isCheck: false,
      });
      this.showRight = false;
      this.isSave = false;
    },
    async getMyClothes() {
      const { content } = await myClothes({ type: 1 });
      this.dataList = content.map((item) => {
        item.isCheck = false;
        return item;
      });
    },
    async getMyDonateQueryCondition() {
      const { content } = await myDonateQueryCondition();
      this.rightObj = content;
    },
  },
};
</script>

<style lang="scss" scoped>
.registerWrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
  padding-bottom: 37px;
  margin-top: 96px;

  .titleBox {
    margin-top: 55px;
    padding: 0px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      height: 56px;
      font-size: 44px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 56px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        margin-left: 16px;
      }
    }

    span {
      width: 60px;
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #679fd2;
      line-height: 42px;
    }
  }

  .listBox {
    margin-top: 41px;
    width: 100%;

    ul {
      width: 100%;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 26px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
        height: 120px;

        .checkboxClass {
          margin-left: 46px;

          font-size: 16px;
        }

        .sizeClass {
          margin-left: 32px;
        }

        .sexClass {
          margin: 0px 24px;
        }

        .countBox {
          width: 164px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
          }

          .numberboxClass {
            width: 56px;
            height: 36px;
            background: #f5f5f5;
            border-radius: 2px;
            border: none;
            text-align: center;
          }
        }

        .deleteClass {
          width: 30px;
          height: 30px;
          margin-right: 32px;
        }
      }
    }
  }

  .addInfoClass {
    width: 320px;
    height: 72px;
    background: #ffffff;
    border-radius: 48px;
    border: 2px solid #dddddd;
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #679fd2;
    text-align: left;
    padding-left: 128px;
    background-image: url("https://img.bbalt.cn/imgh5/userCenter/icon_addInfo.svg");
    background-size: 40px 40px;
    background-repeat: no-repeat;
    background-position: 72px 16px;
    margin-bottom: 101px;
  }

  .footBox {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 220px;
    background: #ffffff;
    box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0px 0px 16px 16px;
    display: flex;
    justify-content: space-between;

    .buttonClass {
      width: 304px;
      height: 88px;
      background: #fe66a6;
      box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 88px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-top: 16px;
      margin-right: 32px;
    }

    .btnListBox {
      display: flex;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-left: 64px;
      height: 80px;
      margin-top: 16px;

      input {
        margin-right: 24px;
      }

      span {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &.beiLanClass {
        margin-left: 22px;

        color: #666666;
        font-size: 24px;

        input {
          margin-right: 0px;
          margin-bottom: 8px;
        }

        span {
          flex-flow: column;
          width: 96px;
          margin-right: 12px;
        }

        img {
          margin-bottom: 8px;
          width: 40px;
          height: 40px;
        }
      }
    }

    .beiLanBtn {
      margin-right: 32px;

      button {
        width: 160px;
        height: 88px;
        border: none;
        box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
        margin-top: 16px;
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);

        &:first-child {
          background: #a0be5b;
          border-radius: 100px 0px 0px 100px;
        }

        &:last-child {
          background: #fe66a6;
          border-radius: 0px 100px 100px 0px;
        }
      }
    }
  }

  .van-popup {
    .titleClass {
      height: 60px;
      widows: 100%;
      text-align: left;
      padding: 10px 10px 10px 40px;
      background: #f5f5f5;
    }

    ul {
      margin: 10px 30px;
      display: flex;
      flex-wrap: wrap;

      li {
        display: inline-block;
        width: 140px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background: #f5f5f5;
        border-radius: 10px;
        margin: 10px 20px;
        font-size: 22px;

        &.active {
          background: #fe66a6;
          color: #fff;
        }
      }
    }

    .countBox {
      margin: 10px 40px;
      width: 164px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
      }

      .numberboxClass {
        width: 56px;
        height: 36px;
        background: #f5f5f5;
        border-radius: 2px;
        border: none;
        text-align: center;
      }
    }

    .buttonBox {
      border-top: 1px solid #eee;
      width: 100%;
      padding: 30px 0px;
      display: flex;
      justify-content: space-around;
      margin-top: 20px;

      button {
        width: 180px;
        height: 56px;
        border-radius: 28px;
        font-size: 28px;
        font-weight: 400;
      }

      .cancelButton {
        background: #eeeeee;
        border: 1px solid #dddddd;
        color: #333333;
      }

      .rightButton {
        background: #fe66a6;
        border-radius: 28px;
        color: #ffffff;
        border: none;
      }
    }
  }
}

.van-dialog p {
  padding: 20px;
  line-height: 40px;
  text-align: left;
}

::v-deep .van-dialog__header {
  color: #000;
}
</style>
